export default "__VITE_ASSET__Ba0NyEIq__"